import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // 如果你的連結是帶 # 這種
    // to.hash 就會有值(值就是連結)
    // 例如 #3
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition;
    } else {
      if (to.hash) {
        return {
          // 這個是透過 to.hash 的值來找到對應的元素
          // 照你的 html 來看是不用多加處理這樣就可以了
          // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
          selector: to.hash,
        };
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/CaaS",
      name: "caas",
      component: () => import("./views/Caas.vue"),
    },
    {
      path: "/RedteaGo",
      name: "RedteaGo",
      component: () => import("./views/RedteaGo.vue"),
    },
    {
      path: "/RedteaReady",
      name: "RedteaReady",
      component: () => import("./views/RedteaReady.vue"),
    },
    {
      path: "/RedteaSIM",
      name: "RedteaSIM",
      component: () => import("./views/RedteaSIM.vue"),
    },
    {
      path: "/Resources",
      name: "Resources",
      component: () => import("./views/Resources.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue"),
    },
    {
      path: "/Contact",
      name: "Contact",
      component: () => import("./views/Contact.vue"),
    },
    {
      path: "/esim-plus",
      name: "esim-plus",
      component: () => import("./views/Esim-plus.vue"),
    },
    {
      path: "/enquiry-mobile",
      name: "enquiry-mobile",
      component: () => import("./views/enquiry-mobile.vue"),
    },
    {
      path: "/coverage",
      name: "coverage",
      component: () => import("./views/article/coverage.vue"),
    },
    {
      path: "/article0",
      name: "article0",
      component: () => import("./views/article/news/article0.vue"),
    },
    {
      path: "/article1",
      name: "article1",
      component: () => import("./views/article/news/article1.vue"),
    },
    {
      path: "/article2",
      name: "article2",
      component: () => import("./views/article/news/article2.vue"),
    },
    {
      path: "/article3",
      name: "article3",
      component: () => import("./views/article/news/article3.vue"),
    },
    {
      path: "/article4",
      name: "article4",
      component: () => import("./views/article/news/article4.vue"),
    },
    {
      path: "/article5",
      name: "article5",
      component: () => import("./views/article/news/article5.vue"),
    },
    {
      path: "/article6",
      name: "article6",
      component: () => import("./views/article/news/article6.vue"),
    },
    {
      path: "/article7",
      name: "article7",
      component: () => import("./views/article/news/article7.vue"),
    },
    {
      path: "/article8",
      name: "article8",
      component: () => import("./views/article/news/article8.vue"),
    },
    {
      path: "/article17",
      name: "article17",
      component: () => import("./views/article/news/article17.vue"),
    },
    {
      path: "/article18",
      name: "article18",
      component: () => import("./views/article/news/article18.vue"),
    },
    {
      path: "/article9",
      name: "article9",
      component: () => import("./views/article/reports/article9.vue"),
    },
    {
      path: "/article10",
      name: "article10",
      component: () => import("./views/article/reports/article10.vue"),
    },
    {
      path: "/article11",
      name: "article11",
      component: () => import("./views/article/reports/article11.vue"),
    },
    {
      path: "/article12",
      name: "article12",
      component: () => import("./views/article/insights/article12.vue"),
    },
    {
      path: "/article13",
      name: "article13",
      component: () => import("./views/article/insights/article13.vue"),
    },
    {
      path: "/article14",
      name: "article14",
      component: () => import("./views/article/insights/article14.vue"),
    },
    {
      path: "/article15",
      name: "article15",
      component: () => import("./views/article/insights/article15.vue"),
    },
    {
      path: "/article16",
      name: "article16",
      component: () => import("./views/article/insights/article16.vue"),
    },
  ],
});
